import { AnyDecodingConsoleLoggerFactory } from './any-decoding-logger';
import { RpcError } from '@square/dashboard-protos/models/Error';
import environment from '@square/environment-utils/environment';
import { getUrlFlag } from '@square/dashboard-utilities/utils/window';
import { generateEnvoyConsentHeader } from '@square/dashboard-utilities/utils/one-trust/one-trust-compliance';
import { getCsrfToken } from '@square/dashboard-utilities/utils/csrf';
import { AuthzEnginesManager } from '@square/authz-engines';
const logRpc = getUrlFlag('logrpc', location);
const env = environment();
const loggingEnabled = Boolean(!env.isHeadless && logRpc !== false && (env.isDevelopment || env.isStaging || logRpc));
export default function rpc(urlForMethod = undefined, options = {}) {
  const {
    loggerFactory = new AnyDecodingConsoleLoggerFactory(loggingEnabled),
    errorDeserializer = RpcError.fromResponse,
    additionalHeaders = new Map(),
    responseParser = undefined,
    sendSpeleoTraceId = false,
    signal = undefined
  } = options;
  return AuthzEnginesManager.emberRpcV1({
    urlForMethod,
    loggerFactory,
    errorDeserializer,
    additionalHeaders: () => {
      const envoyConsentHeader = generateEnvoyConsentHeader();
      const headerMap = new Map([['X-CSRF-Token', getCsrfToken()]]);

      // Adding envoy consent header (only populated if one trust is
      // available to the end users).
      Object.entries(envoyConsentHeader).forEach(([headerKey, headerValue]) => {
        headerMap.set(headerKey, headerValue);
      });
      return new Map([...headerMap, ...additionalHeaders]);
    },
    responseParser,
    sendSpeleoTraceId,
    signal
  });
}